import subscribeForPresenceUpdatesOperation from 'owa-service/lib/operation/subscribeForPresenceUpdatesOperation';

export default function subscribeForPresenceUpdates(sipUris: string[]): Promise<number> {
    return subscribeForPresenceUpdatesOperation({
        sipUris: sipUris,
    });
}
